import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import React from 'react';
import styled from 'styled-components';
import { isYoutube, isVimeo, YOUTUBEMATCH_URL, VIMEOMATCH_URL } from '../urlCheck';
var YOUTUBE_PREFIX = 'https://www.youtube.com/embed/';
var VIMEO_PREFIX = 'https://player.vimeo.com/video/';
var getYoutubeSrc = function getYoutubeSrc(url) {
  var id = url && url.match(YOUTUBEMATCH_URL)[1];
  return {
    srcID: id,
    srcType: 'youtube',
    url: url
  };
};
var getVimeoSrc = function getVimeoSrc(url) {
  var id = url.match(VIMEOMATCH_URL)[3];
  return {
    srcID: id,
    srcType: 'vimeo',
    url: url
  };
};
var getSrc = function getSrc(_ref) {
  var src = _ref.src;
  if (isYoutube(src)) {
    var _getYoutubeSrc = getYoutubeSrc(src),
      srcID = _getYoutubeSrc.srcID;
    return "".concat(YOUTUBE_PREFIX).concat(srcID);
  }
  if (isVimeo(src)) {
    var _getVimeoSrc = getVimeoSrc(src),
      _srcID = _getVimeoSrc.srcID;
    return "".concat(VIMEO_PREFIX).concat(_srcID);
  }
  return null;
};
var IframeContainer = styled.div.withConfig({
  displayName: "VideoBlock__IframeContainer",
  componentId: "sc-1yg98l-0"
})(["position:relative;width:100%;height:0;padding-bottom:56.25%;"]);
var VideoIframe = styled.iframe.withConfig({
  displayName: "VideoBlock__VideoIframe",
  componentId: "sc-1yg98l-1"
})(["position:absolute;top:0;left:0;width:100%;height:100%;"]);
export var VideoBlock = function VideoBlock(_ref2) {
  var blockProps = _ref2.blockProps;
  var src = getSrc(blockProps);
  if (src) {
    return React.createElement(IframeContainer, null, React.createElement(VideoIframe, {
      src: src,
      frameBorder: "0",
      allowFullScreen: true
    }));
  }
  return null;
};